export default function ArrowUpRight() {
    return (
        <svg width="100%" height="100%" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.83203 5.83325H14.1654M14.1654 5.83325V14.1666M14.1654 5.83325L5.83203 14.1666" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
        </svg>


    )
}